import { useNavigate } from 'react-router-dom';
import { shouldSubmitSearch } from '../searchSubmit';
import { useLandingCategories } from '../useLandingCategories';
import {
  isDealsOfTheDayHomeEnabled,
  LANDING_ENGAGING_SEARCH_PLACEHOLDER,
  LANDING_ENGAGING_SEO_TITLE,
} from '../homepageConfig';
import { LogoMark } from './LogoMark';
import { SearchField } from './SearchField';
import { SearchStatsLine } from './SearchStatsLine';
import { CategoryList } from './CategoryList';
import { LandingCategoryChipRail } from './LandingCategoryChipRail';
import { SiteFooter } from './SiteFooter';
import { PageHead } from './PageHead';
import { DEFAULT_DESCRIPTION, HOME_WEBSITE_JSON_LD } from '../seo';
import './SearchResultsPage.css';
import './LandingPage.css';

export function LandingPageEngaging() {
  const navigate = useNavigate();
  const {
    categories,
    comingSoonCategories,
    categoriesLoading,
    categoriesError,
  } = useLandingCategories();
  const showDealsOfTheDayHome = isDealsOfTheDayHomeEnabled();

  function goToSearch(query) {
    const trimmed = typeof query === 'string' ? query.trim() : '';
    if (!shouldSubmitSearch(trimmed)) {
      return;
    }
    navigate(`/search?q=${encodeURIComponent(trimmed)}`);
  }

  const footerCategories = [...categories, ...comingSoonCategories];

  return (
    <>
      <PageHead
        title="Compare products from online shops in Malta | Shops.mt"
        description={DEFAULT_DESCRIPTION}
        canonicalPath="/"
        jsonLd={HOME_WEBSITE_JSON_LD}
      />
      <main className="landing landing--engaging">
        <section
          className="landing-hero-card landing-hero-card--search-first"
          aria-label="Search"
          style={{
            '--landing-hero-bg-image-mobile': `url(${process.env.PUBLIC_URL}/hero2-compressed2.jpeg)`,
            '--landing-hero-bg-image-desktop': `url(${process.env.PUBLIC_URL}/hero-desktop8.jpg)`,
          }}
        >
          <div className="landing-hero-card__logo">
            <LogoMark />
          </div>
          <div className="landing-hero-card__content">
            <h1 className="landing__seo-title landing__seo-title--hero">
              {LANDING_ENGAGING_SEO_TITLE}
            </h1>
            <SearchField
              className="search-bar--landing-hero"
              onSubmitSearch={goToSearch}
              gaSearchLocation="home"
              placeholder={LANDING_ENGAGING_SEARCH_PLACEHOLDER}
            />
            <SearchStatsLine />
          </div>
        </section>
        {!categoriesLoading && (categories.length > 0 || showDealsOfTheDayHome) && (
          <LandingCategoryChipRail
            categories={categories}
            showDealsOfTheDay={showDealsOfTheDayHome}
          />
        )}
        <CategoryList
          categories={categories}
          comingSoonCategories={comingSoonCategories}
          categoriesLoading={categoriesLoading}
          errorMessage={categoriesError}
          layoutVariant="engaging"
          showDealsOfTheDayHome={showDealsOfTheDayHome}
        />
      </main>
      <SiteFooter browseCategories={footerCategories} />
    </>
  );
}
